import React, { useState, useEffect } from 'react';
import {
	useParams, useNavigate, useLocation, useOutletContext,
} from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';

import Comment from './sub-components/comment';

import SpinnerContainer from '../../../component-library/spinner-container';
import ButtonIcon from '../../../component-library/button-icon';

const ContactProviderExpanded = () => {
	const { uiMenuConfig } = useOutletContext();
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const { id, convId, order } = useParams();
	const [loading, setLoading] = useState(true);
	const [commentData, setCommentData] = useState({});
	const [replyNotificationData, setReplyNotificationData] = useState([]);
	const maxCommentLength = 512;

	const clearReplies = () => {
		fetchData({
			uri: `/api/web/my/store/replies/${id}/under/${convId}/${order}/clear`,
			method: 'PUT',
		});
	};

	const getCommentData = () => {
		setLoading(true);
		fetchData({
			uri: `/api/web/asks/catitem/${id}/conv/${convId}/${order}`,
			method: 'GET',
		})
			.then(res => {
				const newCommentData = res.body;
				setCommentData(newCommentData);
				setLoading(false);
				clearReplies();
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const getReplyNotificationData = () => {
		fetchData({
			uri: '/api/web/my/store',
			method: 'GET',
		})
			.then(res => {
				const newRepliesData = res.body.replies;
				const newRepliesArray = [];
				newRepliesData.forEach(reply => {
					const lastBranch = reply.conversationBranches.slice(-1);
					newRepliesArray.push(lastBranch[0].key);
				});
				setReplyNotificationData(newRepliesArray);
				getCommentData();
			});
	};

	const viewFullList = () => {
		navigate('../contact-provider');
	};

	useEffect(() => {
		getReplyNotificationData();
	}, [pathname]);

	return (
		<>
			<div className="flex-row justify-space-between align-items-flex-start border-bottom margin-bottom-16">
				<h3>{uiMenuConfig?.contactProvider?.label || 'Contact Provider'}</h3>
			</div>
			{loading && (
				<SpinnerContainer padding={false} />
			)}
			{!loading && (
				<div className="comments margin-bottom-24">
					<div className="flex-row margin-bottom-16">
						<ButtonIcon
							icon="chevron-left"
							label="View all questions/requests"
							onClick={() => viewFullList()}
						/>
					</div>
					<Comment
						id={id}
						comment={commentData}
						canReply
						maxCommentLength={maxCommentLength}
						autoExpand
						replyNotifications={replyNotificationData}
					/>
				</div>
			)}
		</>
	);
};

export default ContactProviderExpanded;
